import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import AdminLogin from "./AdminLogin";
import AdminApp from "./AdminApp";

export default function AdminRoot({ onSiteReload }) {
  const [status, setStatus] = useState("checking"); // checking | in | out
  const nav = useNavigate();

  const check = async () => {
    try {
      const s = await api.adminSession();
      setStatus(s.authenticated ? "in" : "out");
    } catch {
      setStatus("out");
    }
  };

  useEffect(() => {
    check();
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center text-ivory-dim">
        Loading...
      </div>
    );
  }
  if (status === "out") return <AdminLogin onSuccess={check} />;
  return <AdminApp onSiteReload={onSiteReload} />;
}
